import type { Track } from "@/types/types";
import { CoverImg } from "@/components/ui/CoverImg";
import { IconPlay } from "@/components/ui/icons";
import { useIsMobile } from "@/hooks/useIsMobile";
import { usePlayer } from "@/hooks/usePlayer";

interface P { track: Track; onPlay?: () => void }

export function QuickPickCard({ track, onPlay }: P) {
  const p = usePlayer();
  const isMobile = useIsMobile(800);
  const cover = isMobile ? 48 : 100;
  return (
    <button
      onClick={() => { if (onPlay) onPlay(); else void p.playOne(track); }}
      className="card"
      style={{
        display: "flex",
        alignItems: "center",
        gap: 10,
        padding: isMobile ? 6 : 8,
        paddingRight: isMobile ? 8 : 12,
        textAlign: "left",
        minWidth: 0,
      }}
    >
      <CoverImg
        coverId={track.album?.cover_id}
        alt={track.title}
        size={cover}
        className="cover"
      />
      <div style={{ flex: 1, minWidth: 0 }}>
        <div className="trunc" style={{ fontWeight: 600, fontSize: isMobile ? 13 : 14 }}>
          {track.title}
        </div>
        <div className="muted trunc" style={{ fontSize: isMobile ? 12 : 13 }}>
          {track.artist.name}
        </div>
      </div>
      {/* Play icon: kept on desktop as an affordance hint; dropped on mobile since
          the whole card is already a play button and it was eating the title space. */}
      {!isMobile && (
        <span style={{ opacity: .7, flexShrink: 0, marginLeft: 4 }}>
          <IconPlay />
        </span>
      )}
    </button>
  );
}
